import { checkoutAuthHeaders } from '../checkout/checkoutAuthHeaders';

/** @param {object} line */
export function cartLinePayload(line) {
  return {
    category_slug: line.categorySlug,
    product_external_id: line.productId,
    categorySlug: line.categorySlug,
    productId: line.productId,
    customization: line.customization || '',
    customization_text: line.customization || '',
    quantity: line.qty,
    qty: line.qty,
    product_name: line.name || '',
    name: line.name || '',
    unit_price: line.price,
    price: line.price,
    image_url: line.image || '',
    image: line.image || '',
  };
}

/** @param {Array<object>} rows */
export function serverRowsToCartLines(rows) {
  if (!Array.isArray(rows)) return [];
  return rows
    .map((row) => {
      const customization = String(row.customization_text ?? row.customization ?? '').trim();
      const price = Number(row.unit_price ?? row.price) || 0;
      const qty = Math.max(1, Math.min(99, Number(row.quantity ?? row.qty) || 1));
      return {
        categorySlug: String(row.category_slug ?? row.categorySlug ?? ''),
        productId: String(row.product_external_id ?? row.productId ?? ''),
        name: String(row.product_name ?? row.name ?? ''),
        price,
        image: String(row.image_url ?? row.image ?? ''),
        stockQty: null,
        customization,
        qty,
      };
    })
    .filter((line) => line.categorySlug && line.productId && line.price > 0);
}

export async function cartApiPost(action, extra = {}) {
  let r;
  try {
    r = await fetch('/api/customer.php', {
      method: 'POST',
      headers: checkoutAuthHeaders(),
      body: JSON.stringify({ action, ...extra }),
    });
  } catch {
    return { ok: false, error: 'Network error — server unreachable.' };
  }
  let d = {};
  try {
    d = await r.json();
  } catch {
    return { ok: false, error: 'Invalid response from server.' };
  }
  if (!r.ok || !d.success) {
    return { ok: false, error: d.error || 'Request failed.', status: r.status };
  }
  return { ok: true, data: d };
}
